/*
  Stop Swiper autoplay while a carousel is off screen; start it again when it scrolls back in.

  Swiper 11's autoplay runs a requestAnimationFrame loop (60 times a second) for as long as autoplay is
  running, only to publish `autoplayTimeLeft`, plus a slide transition every `delay`. Paused autoplay
  keeps the loop going; only stop() ends it. On the PDP the two review carousels (2,000+px down)
  autoplayed for the whole visit: ~7% of the main thread in a 4x-throttled load trace, competing with
  every tap.

  Installed once as a global Swiper module, so it covers every carousel created afterwards without
  touching their own code. It only restarts carousels it stopped itself: one stopped by the shopper,
  by disableOnInteraction, or by a component's own logic (the hero carousels already manage their
  autoplay) is left alone.
*/
(function () {
  var Swiper = window.Swiper;
  if (!Swiper || typeof Swiper.use !== 'function' || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var swiper = entry.target.swiper;
      if (!swiper || swiper.destroyed || !swiper.autoplay) continue;
      if (entry.isIntersecting) {
        if (swiper.__scOffscreenStopped) {
          swiper.__scOffscreenStopped = false;
          swiper.autoplay.start();
        }
      } else if (swiper.autoplay.running) {
        swiper.__scOffscreenStopped = true;
        swiper.autoplay.stop();
      }
    }
  });

  Swiper.use([function ScOffscreenAutoplay(ctx) {
    var swiper = ctx.swiper;
    ctx.on('init', function () {
      if (swiper.params.autoplay && swiper.params.autoplay.enabled && swiper.el) io.observe(swiper.el);
    });
    ctx.on('beforeDestroy', function () {
      if (swiper.el) io.unobserve(swiper.el);
    });
  }]);
})();
